import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';

const CONSENT_KEY = 'kivera_cookie_consent';
const CONSENT_VERSION = '1';

// Hide on legal pages so the banner doesn't cover the very content user came to read
const HIDDEN_ON_PATHS = ['/datenschutz', '/impressum', '/agb'];

export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      // Show after small delay so it doesn't flash on first render
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(
      CONSENT_KEY,
      JSON.stringify({
        version: CONSENT_VERSION,
        accepted: true,
        timestamp: new Date().toISOString(),
      })
    );
    setVisible(false);
  };

  if (!visible) return null;
  if (HIDDEN_ON_PATHS.includes(location.pathname)) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-50 animate-in fade-in slide-in-from-bottom-4 duration-300"
    >
      <div className="bg-white border border-slate-200 rounded-xl shadow-2xl p-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center flex-shrink-0">
            <Cookie className="h-5 w-5 text-emerald-600" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2">
              <h3
                className="font-semibold text-slate-900 text-base"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                Nur das Nötigste
              </h3>
              <button
                onClick={accept}
                aria-label="Schließen"
                data-testid="cookie-banner-close"
                className="text-slate-400 hover:text-slate-600 -mt-1 -mr-1"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
            <p className="text-sm text-slate-600 mt-1 leading-relaxed">
              Kivera nutzt ausschließlich technisch notwendige Cookies und localStorage-Einträge
              (z. B. zum Speichern Ihres Logins). Es findet kein Tracking statt – keine Analyse-
              oder Marketing-Cookies.
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-3">
              <Button
                size="sm"
                onClick={accept}
                data-testid="cookie-banner-accept"
                className="bg-slate-900 hover:bg-slate-800 text-white"
              >
                Verstanden
              </Button>
              <Link
                to="/datenschutz"
                onClick={accept}
                data-testid="cookie-banner-datenschutz-link"
                className="text-sm text-slate-500 hover:text-slate-900 underline-offset-2 hover:underline"
              >
                Mehr im Datenschutz
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
